/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const PromptTypeQueryEnum = core.serialization.enum_(["ALL", "AI_ASSIST", "CONSTRAINT_GENERATION"]);
